


<div *ngFor="let menu of parentMenu" class="menu-item">
    <a *ngIf="menu.routerLink && !menu.hasSubMenu" mat-button style="display: flex; flex-direction: row; align-items: center;" 
        [style.justify-content]="(settings.menuType=='default') ? 'start' : 'center'"
        [routerLink]="menu.enable !== false ? [menu.routerLink] : null" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" [class.disabled-menu]="menu.enable === false"
        [matTooltip]="menu.title" matTooltipPosition="after" [matTooltipDisabled]="(settings.menuType=='mini') ? 'false' : 'true'"
        (click)="onClick(menu.id)"(click)="menu.enable !== false && onClick(menu.id)" [id]="'menu-item-'+menu.id">
        <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
        <span class="menu-title">{{menu.title | translate}}</span>
    </a>
    <a *ngIf="menu.href && !menu.subMenu" mat-button 
        style="display: flex; flex-direction: row; align-items: center;" [style.justify-content]="(settings.menuType=='default') ? 'start' : 'center'"
        [attr.href]="menu.href || ''" [attr.target]="menu.target || ''"
        [matTooltip]="menu.title" matTooltipPosition="after" [matTooltipDisabled]="(settings.menuType=='mini') ? 'false' : 'true'"
        (click)="onClick(menu.id)" [id]="'menu-item-'+menu.id">
        <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
        <span class="menu-title">{{menu.title | translate}}</span>
    </a>
    <a *ngIf="menu.hasSubMenu" mat-button 
        style="display: flex; flex-direction: row; align-items: center;" [style.justify-content]="(settings.menuType=='default') ? 'start' : 'center'"
        [matTooltip]="menu.title" matTooltipPosition="after" [matTooltipDisabled]="(settings.menuType=='mini') ? 'false' : 'true'"
        (click)="onClick(menu.id)" [id]="'menu-item-'+menu.id">
        <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
        <span class="menu-title">{{menu.title | translate}}</span>
        <mat-icon class="menu-expand-icon transition-2" style="margin-bottom: 20px;">arrow_drop_down</mat-icon>
    </a>

    <div *ngIf="menu.hasSubMenu" class="sub-menu" [id]="'sub-menu-'+menu.id">
        <app-vertical-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-vertical-menu>
    </div>
</div>